import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie'
import axiosinstance from '../axios/axiosInstance';
import { unregisterPushToken } from '../utils/nativePush';
import { saveAuth, clearAuth } from '../utils/authStorage';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   // Check if JWT token exists in cookies
  //   const uid = Cookies.get('uid');
  //   if (uid) {
  //     setIsAuthenticated(true);
  //   }
  //   setLoading(false);
  // }, []);

  useEffect(() => {
  const uid = Cookies.get('uid');
  const user_id = Cookies.get('user_id');

  const validateToken = async () => {
    try {
      const res = await axiosinstance.post("/user/validate-session", { user_id }, {
        headers: {
          Authorization: uid
        }
      });

      if (res.status === 200 && res.data.valid) {
        setIsAuthenticated(true);
      } else {
        // Invalid token or inactive session
        Cookies.remove('uid');
        Cookies.remove('user_id');
        clearAuth();
        setIsAuthenticated(false);
      }
    } catch (err) {
      // Only log out on a genuine auth rejection (401). A network/server error
      // (no response) on cold start must NOT wipe the session — otherwise a brief
      // connectivity blip logs the user out, especially in the native app.
      if (err?.response?.status === 401) {
        Cookies.remove('uid');
        Cookies.remove('user_id');
        clearAuth();
        setIsAuthenticated(false);
      } else {
        // Keep the saved session and let the user in; subsequent API calls will
        // surface a real 401 if the token is actually invalid.
        setIsAuthenticated(true);
      }
    }

    setLoading(false);
  };

  if (uid && user_id) {
    validateToken();
  } else {
    setLoading(false);
  }
}, []);


  const login = async (data) => {
    Cookies.set('uid', data.token, { expires: 7, secure: true, sameSite: 'strict' })
    Cookies.set('user_id', data.user_id, { expires: 7, secure: true, sameSite: 'strict' })
    // Mirror to native storage so the session survives app restarts (no-op on web).
    // AWAIT it: the native Preferences write is async, and if the app is closed
    // right after login (common with the Google one-tap flow) a fire-and-forget
    // write can be lost — leaving nothing to rehydrate on next launch, so the
    // user appears logged out. Awaiting guarantees the write is flushed before
    // callers navigate away.
    await saveAuth(data.token, data.user_id);

    setIsAuthenticated(true);
  };
  const logout = async () => {
    try {
      const token = Cookies.get('uid');
      const user_id = Cookies.get('user_id');

      if (token && user_id) {
        // Stop native push to this device for the logged-out user.
        unregisterPushToken();
        axiosinstance.post("/user/logout", { user_id }, {
          headers: {
            'Authorization': Cookies.get('uid')
          }
        }).then((res) => {
          if (res.status == 200) {
            Cookies.remove('uid');
            Cookies.remove('user_id');
            clearAuth();
            setIsAuthenticated(false);
          } else {
            console.error('Logout failed:');
          }
        })
      }
    } catch (error) {
      console.error('Logout failed:', error);
    }

  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}